import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { Spinner } from 'reactstrap';
function TripOrder() {
  const [orders, setOrders] = useState([]);
  const [tripNumber, setTripNumber] = useState([]);
  const { id } = useParams();
  const [IsLoading, setIsLoading] = useState(true)
  useEffect(() => {
    if (id > 0) {
      loadOrders();
    }
  }, []);

  const loadOrders = () => {
    var response = callAPI(`/api/trips/${id}/order/0`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        setOrders(res.data);
      } else {
        toast.error(res.message);
      }
      if (res.data.length > 0) {
        var order = res.data[0];
        setTripNumber(order.TripNumber);
      }
    });
  };

  const updateOrderStatus = (orderId) => {
    setIsLoading(true)
    var body = {
      Id: orderId,
      Status: 3,
    };
    var response = callAPI(`/api/order-status`, "POST", JSON.stringify(body));
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        toast.success("Order Status Updated!!!");
        setTimeout(() => {
          loadOrders();
        }, 1000);
      } else {
        toast.error(res.message);
      }
    });
  };

  const removeOrderFromTrip = (orderId) => {
    setIsLoading(true)
    var response = callAPI(`/api/removetriporder/${id}/${orderId}`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        toast.success(res.message);
        setTimeout(() => {
          loadOrders();
        }, 1000);
      } else {
        toast.error(res.message);
      }
    });
  };


  let renderRow = orders.map((order) => {
    return (
    
      <tr key={order.OrderId}>
        <td className="td-actions text-left">
          {order.OrderStatusId != 3 ? (
            <>
              <button
                data-tip
                data-for="MarkDelivered"
                type="button"
                className="btn btn-success"
                value={order.OrderId}
                onClick={(e) => updateOrderStatus(order.OrderId)}
              >
                <i className="now-ui-icons tech_watch-time" />
              </button>
              <ReactTooltip id="MarkDelivered" place="top" effect="solid">
                Mark Order As Delivered
              </ReactTooltip>
              &nbsp;
              <button
                data-tip
                data-for="RemoveFromTrip"
                type="button"
                className="btn btn-danger"
                value={order.OrderId}
                onClick={(e) => removeOrderFromTrip(order.OrderId)}
              >
               <i className="now-ui-icons ui-1_simple-remove" />
              </button>
              <ReactTooltip id="RemoveFromTrip" place="top" effect="solid">
                Remove Order From Trip
              </ReactTooltip>
            </>
          ) : (
            ""
          )}
        </td>
        <td className="text-left">{order.OrderNumber}</td>
        <td className="text-left">{order.ReceiverName}</td>
        <td className="text-left">
          {order.Address} <br />
          {order.City}, {order.State} {order.Zip} <br />
          Lat: {order.Lat} <br />
          Long: {order.Long}
        </td>
        <td className="text-left">{order.OrderStatus}</td>
      </tr>
    );
  });

  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>

      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                <CardTitle tag="h4">
                  <strong>Trip No:</strong> {tripNumber}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Order Number</th>
                      <th>Receiver Name</th>
                      <th>Address</th>
                      <th>Order Status</th>
                    </tr>
                  </thead>
                  <tbody>{renderRow}</tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <div className="stats"></div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TripOrder;
